import { Link } from 'react-router-dom';
import { Github, Twitter, MessageCircle, FileText, Download } from 'lucide-react';

export const Footer = () => {
  const whitepaperUrl = "https://github.com/GGPAYCOIN/WHITE-PEAPER/blob/main/ggpay_ggchain_whitepaper%20(1).md";

  return (
    <footer className="explorer-footer" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1: Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_ggchain-mining/artifacts/ohlkkprt_20250622_223359.png" 
                alt="GG CHAIN" 
                className="w-14 h-14 rounded-full object-cover"
              />
              <div>
                <h3 className="font-bold">GG CHAIN</h3>
                <p className="text-xs text-muted-foreground">Explorer</p>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Hybrid PoW + PoS Layer-1 blockchain with 21M max supply.
            </p>
          </div>

          {/* Column 2: Explorer */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Explorer</h4>
            <ul className="space-y-2">
              <li><Link to="/blocks" className="text-sm hover:text-primary transition-colors">Blocks</Link></li>
              <li><Link to="/transactions" className="text-sm hover:text-primary transition-colors">Transactions</Link></li>
              <li><Link to="/mempool" className="text-sm hover:text-primary transition-colors">Mempool</Link></li>
              <li><Link to="/stats" className="text-sm hover:text-primary transition-colors">Statistics</Link></li>
            </ul>
          </div>

          {/* Column 3: Network */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Network</h4>
            <ul className="space-y-2">
              <li><Link to="/validators" className="text-sm hover:text-primary transition-colors">Validators</Link></li>
              <li><Link to="/miners" className="text-sm hover:text-primary transition-colors">Miners</Link></li>
              <li><Link to="/tokenomics" className="text-sm hover:text-primary transition-colors">Tokenomics</Link></li>
              <li><Link to="/api-docs" className="text-sm hover:text-primary transition-colors">API Docs</Link></li>
            </ul>
          </div>

          {/* Column 4: Community & Downloads */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Community</h4>
            <div className="flex gap-3 mb-4">
              <a href="#" className="p-2 rounded-lg hover:bg-white/10 transition-colors" aria-label="Github">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-lg hover:bg-white/10 transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-lg hover:bg-white/10 transition-colors" aria-label="Discord">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-lg hover:bg-white/10 transition-colors" aria-label="Docs">
                <FileText className="w-5 h-5" />
              </a>
            </div>
            
            {/* Whitepaper Download Button */}
            <a 
              href={whitepaperUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#00F0FF]/10 hover:bg-[#00F0FF]/20 border border-[#00F0FF]/30 text-[#00F0FF] text-sm font-medium transition-colors"
              data-testid="whitepaper-download"
            >
              <Download className="w-4 h-4" />
              Whitepaper
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2024 GG CHAIN. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
              Network Online
            </span>
            <span>Chain ID: ggchain-mainnet-1</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
